<template>
  <div class="list">
    <div class="list-filter">
      <el-form :inline="true" :model="queryEntity" class="demo-form-inline">
        <el-form-item label="客户端名称">
          <el-input size="medium" v-model="queryEntity.name" placeholder="客户端名称"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select class="list-filter-state" clearable v-model="queryEntity.type" size="small" placeholder="全部类型" style="width:140px">
            <el-option v-for="item in types" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="list-btn-select" size="small" type="primary" @click="selectList">查询</el-button>
          <el-button class="list-btn-reset" size="small" @click="resetSelect">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="list-tool cf">
      <div class="fl">
        <el-button class="list-btn" size="small" type="primary" :disabled="disableAuth('add')" @click="add">新增</el-button>
        <el-button class="list-btn" size="small" type="danger" :disabled="disableAuth('delete')" @click="deleteList">批量删除</el-button>
      </div>
      <div class="fr">
      </div>
    </div>
    <div class="list-table">
      <el-table :data="dataList" :header-cell-class-name="headerCellClass" :max-height="tableHeight" stripe @selection-change="handleSelectionChange" size="medium">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="no" label="序号" width="50" fixed> </el-table-column>
        <el-table-column prop="code" label="编号" width="120"> </el-table-column>
        <el-table-column prop="name" label="客户端名称" width="320"> </el-table-column>
        <el-table-column prop="typeName" label="类型" width="120"> </el-table-column>
        <el-table-column prop="stateName" label="状态" width="160"> </el-table-column>
        <el-table-column prop="remark" label="备注"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="210">
          <template #default="scope">
            <el-button type="primary" size="mini" :disabled="disableAuth('view')" @click="view(scope)">查看</el-button>
            <el-button type="success" size="mini" :disabled="disableAuth('modify')" @click="modify(scope)">修改</el-button>
            <el-button type="danger" size="mini" :disabled="disableAuth('delete')" @click="deleteItem(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="list-pager">
      <el-pagination class="list-pager-inner" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" v-model:currentPage="queryParam.pager.pageIndex" v-model:page-size="queryParam.pager.pageSize" :total="queryParam.pager.total" layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script lang="ts">
import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext } from "@/script/core/base/ServiceData";
import { createClientContext } from "@/script/apps/device/config/DeviceConfig";
import { Client } from "@/script/apps/device/entity/DeviceEntity";
import { DictUtil } from "@/script/core/Dict";

@Options({})
export default class ClientList extends BaseList {
  private queryEntity: Client = {};
  private dataList: Client[] = [];

  public initData(): ServiceContext {
    return createClientContext();
  }

  public initQueryEntity() {
    this.queryEntity = {
      name: "",
    };
    return this.queryEntity;
  }

  public beforeLoadList() {
    if (this.queryEntity.type === "") {
      this.queryEntity.type = undefined;
    }
  }

  public afterLoadList(data: any): void {
    const currDataList: Client[] = data.list as Client[];
    currDataList.forEach((item) => {
      if (this.serviceContext.typesName) {
        item.typeName = DictUtil.getItemName(this.types, item.type);
      }
    });
    this.dataList = currDataList;
  }
}
</script>
